var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7241 0.522561C9.27552 0.649785 9.27141 0.654393 7.36479 3.16079C6.43318 4.38547 5.64433 5.39792 5.61179 5.41074C5.57924 5.42356 4.63204 5.07079 3.5069 4.62679C1.46121 3.8196 1.46121 3.8196 1.14332 3.83907C0.466251 3.88058 0.00220395 4.37069 4.56219e-07 5.04654C-0.00118604 5.413 2.31231 14.605 2.47944 14.8978C2.60423 15.1164 2.79534 15.2876 3.05006 15.4091C3.24075 15.5 3.24075 15.5 9.99954 15.5C16.7583 15.5 16.7583 15.5 16.949 15.4091C17.2037 15.2876 17.3948 15.1164 17.5196 14.8978C17.6697 14.6349 20 5.41765 20 5.08688C20 4.54956 19.6677 4.05579 19.1984 3.89592C18.7535 3.74431 18.6265 3.77891 16.4313 4.65027C15.3425 5.08244 14.4238 5.42513 14.3899 5.41178C14.3559 5.39839 13.5659 4.38547 12.6343 3.16079C10.9157 0.901625 10.7536 0.708463 10.4763 0.589585C10.2865 0.508261 9.89686 0.473532 9.7241 0.522561Z",
    fill: "#F3F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.733bf315268baddb95734f4a990b0bc2.svg";
export { ForwardRef as ReactComponent };